export default __webpack_public_path__ + "static/media/Setores.7b93a4a0.svg";